import React from 'react';
import { useTranslation } from 'react-i18next';
import ActionButton from './ActionButton';
const ReadyStep = ({ editUrl }) => {
    const { t } = useTranslation();
    const handleEdit = () => {
        // eslint-disable-next-line no-undef
        window.location.assign(editUrl);
    };
    return (React.createElement("section", { className: "mx-auto w-full max-w-3xl rounded-2xl border border-gray-200 bg-white px-6 py-16 text-center shadow-sm" },
        React.createElement("span", { className: "material-icons text-5xl text-emerald-600" }, "check_circle"),
        React.createElement("h1", { className: "mt-6 text-2xl font-semibold text-gray-800 md:text-3xl" }, t('pitchCreation.ready.title')),
        React.createElement("p", { className: "mx-auto mt-3 max-w-lg text-gray-700" }, t('pitchCreation.ready.body')),
        React.createElement("div", { className: "mt-8" },
            React.createElement(ActionButton, { label: t('pitchCreation.ready.edit'), onClick: handleEdit }))));
};
export default ReadyStep;
